import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCity = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.493 18.431a2.09 2.09 0 0 1-2.102 2.079H5.1A2.09 2.09 0 0 1 3 18.43v-5.272c.005-.453.22-.878.582-1.152l3.963-3.18a1.924 1.924 0 0 1 2.386 0l3.98 3.177c.36.274.575.698.582 1.15zM8.745 16.723v3.548"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.565 20.4h1.298c1.18 0 2.137-.956 2.137-2.137V5.627c0-1.18-.957-2.136-2.137-2.136H13.64c-1.174 0-2.124.95-2.124 2.124v.878M17.767 16.259v.01M17.767 12.046v-.01M14.707 7.813v.01M17.767 7.813v.01"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCity);
export default ForwardRef;
